module.exports = __webpack_public_path__ + "img/yellow-lily.381ba031.jpg";